import { Component, afterNextRender, input } from '@angular/core';
import { WebformModule } from '@app/components/webform/webform.module';
import { Webform } from '@app/models/entity.model';

@Component({
  selector: 'mobi-node-webform',
  templateUrl: './webform.component.html',
  styleUrls: ['./webform.component.scss'],
  standalone: true,
  imports: [WebformModule],
})
export class WebformComponent {
  readonly entity = input.required<Webform>();
  readonly params = input<URLSearchParams>(new URLSearchParams());

  #afterRender = afterNextRender({
    write: () => {
      // check, if webform component is loaded inside an iframe
      if (window === window.parent) {
        return;
      } else {
        const script = document.createElement('script');
        script.src =
          'https://cdn.jsdelivr.net/npm/iframe-resizer@4.4.2/js/iframeResizer.contentWindow.min.js';
        document.head.appendChild(script);
      }
    },
  });
}
